import { isEntryAnalysisReportType } from "../utils/reportTypeRules";

export const REPORT_NOTE_TAB_KEYS = [
  "overview",
  "market",
  "simulator",
  "trade_review",
  "pine",
] as const;

export type ReportNoteTabKey = (typeof REPORT_NOTE_TAB_KEYS)[number];

export const REPORT_NOTE_TAB_LABELS: Record<ReportNoteTabKey, string> = {
  overview: "Overview",
  market: "Entry Analysis",
  simulator: "Simulation",
  trade_review: "Trade review",
  pine: "Pinescript",
};

/** Card title on each report section tab (and matching Notes hub accordion label). */
export const REPORT_NOTE_TAB_SECTION_HEADINGS: Record<ReportNoteTabKey, string> = {
  overview: "Overview Notes",
  market: "Entry Analysis Notes",
  simulator: "Simulation Notes",
  trade_review: "Trade Review Notes",
  pine: "Pinescript Notes",
};

/** Report section tab index (0–4) → note `tab_key`. Notes hub tab (5) has no tab key. */
export const REPORT_SECTION_INDEX_TO_NOTE_TAB_KEY: Record<number, ReportNoteTabKey> = {
  0: "overview",
  1: "market",
  2: "simulator",
  3: "pine",
};

export function reportNoteTabKeysForReportType(
  reportType?: string
): readonly ReportNoteTabKey[] {
  if (isEntryAnalysisReportType(reportType)) {
    return REPORT_NOTE_TAB_KEYS.filter((key) => key !== "pine");
  }
  return REPORT_NOTE_TAB_KEYS;
}
